<template>
  <div class="DarkWhite pa-4">
      <v-row>
        <v-col cols="12" sm="6" md="8" lg="10">
        <h2 class="subheading green--text">Budget Monitoring & Evaluation</h2>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-autocomplete
          v-model="fiscalYear"
          :items="fiscalyears"
          auto-select-first
          item-text="fiscalYear"
          item-value="id"
          color="header"
          dense
          label="Fiscal Year"
          class="mt-2"
        >
        </v-autocomplete>
      </v-col>
      </v-row>
      <BudgetMAndE :fiscalYear="fiscalYear"/>
  </div>
</template>

<script>
import BudgetMAndE from '../components/Utils/BudgetMAndE.vue'
  export default {
    components: {
      BudgetMAndE
    },
    data: () => ({
      menus: [
        {icon:'mdi-file-compare', title:'PR'},
        {icon:'mdi-file-export', title:'APR'},
        {icon:'mdi-file-move', title:'Canvass'},
        {icon:'mdi-file-search', title:'AOQ'},
        {icon:'mdi-file-import', title:'IAR'},
        {icon:'mdi-file-check', title:'Issuance'}
      ],
      fiscalYear: 0,
      fiscalyears: [],
    }),
    watch: {
      fiscalYear: {
      handler(data) {
        this.$store.dispatch("setFiscalYear", data);
      },
      deep: true,
    },
    },
    mounted() {
      this.getFiscalYears()
    },
    methods: {
      getFiscalYears() {
      this.fiscalyears = [{id: 0, fiscalYear: "All"}]
      this.axiosCall("/getAllFiscalYear", "GET").then((res) => {
        this.fiscalyears = [{id: 0, fiscalYear: "All"}, ...res.data.data]
        this.fiscalYear = this.$store.state.fiscalYear != null ? this.$store.state.fiscalYear : res.data.data[0].id
      });
    },
    }
  }
</script>

<style scoped>
</style>